// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";
import { Api } from "../../../api";
import { Branche } from "../../../common/interfaces/conversionworld/Branche";
import { ImageAspectRatio } from "../../../components/image_aspect_ratio/ImageAspectRatio";
import InlineSVG from "../../../components/inline_svg/InlineSVG";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
    InlineSVG,
  },
})
export class BranchenEinstiegModule extends ModuleBase {
  private branchen: Branche[] = [];

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  created() {
    this.loadBranchen();
  }

  public async loadBranchen() {
    this.branchen = await Api.conversionWorldService.getBranchen(
      this.$store.page.page!.id
    );
  }
}
